import ErrorBoundary from './component';

export default ErrorBoundary;